(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[45],{

/***/ 30045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Blog_PostMobileFooter; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Link.jsx
var Link = __webpack_require__(305);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Blog/Blog.module.scss
var Blog_module = __webpack_require__(61009);
var Blog_module_default = /*#__PURE__*/__webpack_require__.n(Blog_module);
;// CONCATENATED MODULE: ./src/components/Blog/Categories.jsx






var Categories = function(_param) /*#__PURE__*/ {
    var style = _param.style, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "style",
        "className"
    ]);
    return (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Blog_module_default()).box, className),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (Blog_module_default()).header,
                children: "Categories"
            }),
            props.showAll && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: (Blog_module_default()).storyLink,
                title: "All",
                to: "/blog",
                children: "All Categories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: (Blog_module_default()).storyLink,
                title: "Leaders",
                to: "/blog/categories/leaders",
                children: "Leaders"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: (Blog_module_default()).storyLink,
                title: "Digital",
                to: "/blog/categories/digital",
                children: "Digital"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: (Blog_module_default()).storyLink,
                title: "Storytelling",
                to: "/blog/categories/storytelling",
                children: "Storytelling"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: (Blog_module_default()).storyLink,
                title: "Hiring Resources",
                to: "/blog/categories/hiring-resources",
                children: "Hiring Resources"
            })
        ]
    });
};
Categories.propTypes = {
    showAll: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    style: (prop_types_default()).object
};
/* harmony default export */ var Blog_Categories = (Categories);

;// CONCATENATED MODULE: ./src/components/Blog/PostMobileFooter.jsx



// import Recommended from './Recommended';


var PostMobileFooter = function(_param) /*#__PURE__*/ {
    var className = _param.className, recommended = _param.recommended, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "recommended"
    ]);
    return (0,jsx_runtime.jsx)("div", {
        className: (Blog_module_default()).postFooter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_Categories, {})
    });
};
PostMobileFooter.propTypes = {
    recommended: prop_types_default().arrayOf((prop_types_default()).object),
    className: (prop_types_default()).string
};
/* harmony default export */ var Blog_PostMobileFooter = (PostMobileFooter);


/***/ }),

/***/ 61009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"Blog_navContainer__vNa5V","nav":"Blog_nav__Nl6UN","navLink":"Blog_navLink__b6zxI","navActive":"Blog_navActive__IynNn","container":"Blog_container__jlmNK","box":"Blog_box__O3irF","sticky":"Blog_sticky__uDk1k","header":"Blog_header__Are8n","storyItem":"Blog_storyItem__mlxfB","storyImage":"Blog_storyImage__r7k6d","storyTitle":"Blog_storyTitle__zmw04","storyLink":"Blog_storyLink__B_yMc","subscribe":"Blog_subscribe__SmVbM","subscribeMobile":"Blog_subscribeMobile__d5QF5","postFooter":"Blog_postFooter__om5B3","postAside":"Blog_postAside__ZnYXv","postSocialAside":"Blog_postSocialAside__1N6aE","socialSticky":"Blog_socialSticky__B5nJ1","socialButton":"Blog_socialButton__RSC1T"};

/***/ })

}]);